module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "fz24 light mt2"
  }, [_vm._v("Mine ordre")]), _vm._v(" "), _c('p', {
    staticClass: "mt2 mb3"
  }, [_vm._v("Her finner du en ovesikt over dine ordre. Klikk på en av ordrene for å f.eks. laste opp nye filer.")]), _vm._v(" "), (_vm.orders) ? _c('div', [(_vm.orders.length > 0) ? _c('div', {
    staticClass: "card rounded sh1"
  }, [_c('table', {
    staticClass: "order-table",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.orders), function(order, index) {
    return _c('tr', {
      staticClass: "@bg-light-blue"
    }, [_c('td', {
      staticClass: "px3 py2"
    }, [_c('div', {
      staticClass: "fz18 mb1 pointer",
      on: {
        "click": function($event) {
          _vm.viewOrder(order.id)
        }
      }
    }, [_vm._v(_vm._s(order.title))]), _vm._v(" "), (order.lines_count > 1) ? _c('div', [_vm._v(_vm._s(order.lines_count) + " produkter")]) : _c('div', [_vm._v(_vm._s(order.lines_count) + " produkt")])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "text-grey truncate"
    }, [_vm._v(_vm._s(_vm.toLocaleDate(order.created_at.date)))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "fz24 light text-blue truncate"
    }, [_vm._v("kr " + _vm._s(_vm.toLocale(order.gross_total / 100)) + ",-")])]), _vm._v(" "), _c('td', {
      staticClass: "cell-actions center"
    }, [_c('md-button', {
      staticClass: "md-icon-button text-grey",
      nativeOn: {
        "click": function($event) {
          _vm.viewOrder(order.id)
        }
      }
    }, [_c('md-tooltip', [_vm._v("Se detaljer")]), _vm._v(" "), _c('md-icon', [_vm._v("remove_red_eye")])], 1)], 1)])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.orders.length == 0) ? _c('div', {
    staticClass: "card rounded sh1"
  }, [_c('div', {
    staticClass: "p3 center"
  }, [_c('div', {
    staticClass: "fz24 light my3"
  }, [_vm._v("Du har ikke plassert noen ordre ennå...")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary",
    nativeOn: {
      "click": function($event) {
        _vm.goToShop()
      }
    }
  }, [_vm._v("Klikk her for å handle")])], 1)]) : _vm._e()]) : _c('div', {
    staticClass: "p3 center"
  }, [_c('md-spinner', {
    attrs: {
      "md-indeterminate": ""
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-grey "
  }, [_c('th', {
    staticClass: "border-bottom border-light-grey py2 px3 light left-align"
  }, [_vm._v("Bestilling")]), _vm._v(" "), _c('th', {
    staticClass: "border-bottom border-light-grey py2 light left-align"
  }, [_vm._v("Plassert")]), _vm._v(" "), _c('th', {
    staticClass: "border-bottom border-light-grey py2 light left-align",
    attrs: {
      "light": ""
    }
  }, [_vm._v("Total")]), _vm._v(" "), _c('th', {
    staticClass: "border-bottom border-light-grey py2 light"
  }, [_vm._v("Handlinger")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76408b97","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/views/shop/MyOrders.vue
// module id = 646
// module chunks = 1